import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/mark.svg';
const Mark = () => React.createElement(IconSvg, null);
export default Mark;
